import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { useTranslation as g, FAIcon as n } from "@nextgen-web-framework/all";
import u from "../LanguageModal/LanguageModal.js";
import m from "../../utils/useLanguageSelector.js";
import '../../assets/HeaderLanguage.css';const h = "#ffffff", p = "#396e75", z = "#e5fdff", V = "#546223", C = "#f0fae5", _ = "#a65523", w = "#fff1e8", f = "#7f3e3e", k = "#ffe2e2", B = "#62625a", b = "#f8f8e7", G = "#38539a", O = "#707070", L = "#c8f8d1", N = "#87c9c8", R = "#5291b1", W = "rgba(82, 145, 177, 0.1019607843)", v = "#445685", y = "#181d61", H = "rgba(24, 29, 97, 0.1019607843)", Y = "#5969d6", x = "#ea999d", A = "#b6577e", S = "rgba(182, 87, 126, 0.1019607843)", j = "#7e3e80", I = "#1e247f", M = "rgba(30, 36, 127, 0.1019607843)", P = "#da7600", $ = "#107f47", F = "#d91734", T = "_html_mp1cw_38", a = {
  amwayWhite: h,
  darkBlue: p,
  lightBlue: z,
  darkGreen: V,
  lightGreen: C,
  darkOrange: _,
  lightOrange: w,
  darkRed: f,
  lightRed: k,
  darkYellow: B,
  lightYellow: b,
  darkPurple: G,
  darkGrayOnWhite: O,
  dataVizColor1: L,
  dataVizColor2: N,
  dataVizColor3: R,
  dataVizColor3Background: W,
  dataVizColor4: v,
  dataVizColor5: y,
  dataVizColor5Background: H,
  dataVizColor6: Y,
  dataVizColor7: x,
  dataVizColor8: A,
  dataVizColor8Background: S,
  dataVizColor9: j,
  dataVizColor10: I,
  dataVizColor10Background: M,
  dataVizAlertOrange: P,
  dataVizSuccessGreen: $,
  dataVizWarningRed: F,
  "no-visible": "_no-visible_mp1cw_34",
  html: T,
  "card-radio-container": "_card-radio-container_mp1cw_72",
  "header-language-container": "_header-language-container_mp1cw_76",
  "down-section": "_down-section_mp1cw_91",
  "right-down-icon": "_right-down-icon_mp1cw_97",
  "up-section": "_up-section_mp1cw_103",
  "right-up-icon": "_right-up-icon_mp1cw_106",
  "language-title": "_language-title_mp1cw_121",
  "language-modal-wrapper": "_language-modal-wrapper_mp1cw_133"
}, K = ({ locale: r, langHandler: d }) => {
  const i = g(), { showLanguageModal: o, handleLanguageChange: c, languageClickHandler: l, onCloseHandler: s } = m({
    langHandler: d
  });
  return /* @__PURE__ */ t("div", { className: a["header-language-container"], "data-testid": "header-language-container-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ t(
      "section",
      {
        role: "presentation",
        className: `${a["language-title"]} ${o ? a["up-section"] : a["down-section"]}`,
        "data-testid": "language-title-testId",
        "data-pod-name": "commerce",
        onClick: l,
        children: [
          i("web.lang"),
          o ? /* @__PURE__ */ e(n, { className: a["right-up-icon"], iconName: "chevron-up", "data-testid": "right-up-icon-test-id", "data-pod-name": "commerce" }) : /* @__PURE__ */ e(
            n,
            {
              className: a["right-down-icon"],
              iconName: "chevron-down",
              "data-testid": "right-down-icon-test-id",
              "data-pod-name": "commerce"
            }
          )
        ]
      }
    ),
    o && /* @__PURE__ */ e(u, { languageHandler: c, currentLocale: r ?? "", onClose: s })
  ] });
};
export {
  K as default
};
//# sourceMappingURL=HeaderLanguage.js.map
